import {
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
  Stack,
  Typography,
} from "@mui/material";
import CategoryCard from "pages/product_category/CategoryCard";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import {
  categorySelector,
  deleteCategoriesThunk,
  getCategoriesThunk,
} from "store/reducers/product/categorySlice";
import UpdateCategoryDialog from "pages/product_category/UpdateCategoryDialog";
const CategoryList = ({ selectedItem, setSelectedItem }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCategoriesThunk());
  }, []);

  const [contextMenu, setContextMenu] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentItem, setCurrentItem] = React.useState(null);

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setCurrentItem(item);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setContextMenu(null);
  };
  const categories = useSelector(categorySelector.selectAll);
  const handleContextMenu = (event, item) => {
    event.preventDefault();
    setCurrentItem(item);
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
          }
        : null
    );
  };
  const handleDelete = () => {
    dispatch(deleteCategoriesThunk(currentItem.id));
  };

  const [openUpdateDialog, setOpenUpdateDialog] = React.useState(false);

  const handleUpdateClose = () => {
    setOpenUpdateDialog(false);
  };
  const menu = (context) => (
    <Menu
      {...(context
        ? {
            open: contextMenu !== null,
            anchorReference: "anchorPosition",
            anchorPosition:
              contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined,
          }
        : {
            anchorEl: anchorEl,
            open: anchorEl !== null,
          })}
      onClose={handleClose}
      onClick={handleClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuList dense={false}>
        <MenuItem onClick={handleDelete}>
          <ListItemIcon>
            <DeleteOutlineIcon />
          </ListItemIcon>
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenUpdateDialog(true);
          }}
        >
          <ListItemIcon>
            <UpgradeIcon />
          </ListItemIcon>
          Update
        </MenuItem>
      </MenuList>
    </Menu>
  );
  return (
    <>
      <Stack direction="row" spacing={1} sx={{ paddingBottom: 2 }}>
        {categories.map((category) => (
          <CategoryCard
            category={category}
            handleContextMenu={handleContextMenu}
            handleClick={handleClick}
            key={category.id}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
          />
        ))}
        {menu(true)}
        {menu(false)}
      </Stack>
      <UpdateCategoryDialog
        open={openUpdateDialog}
        handleClose={handleUpdateClose}
        category={currentItem}
        fullGrid={false}
      />
    </>
  );
};

export default CategoryList;
